import { render } from "./StockAssemble.vue?vue&type=template&id=6783bba6"
import script from "./StockAssemble.vue?vue&type=script&lang=js"
export * from "./StockAssemble.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__